import { Location } from "@/api/opb/opbTypes";

/* eslint-disable no-shadow */
enum Countries {
  UnitedKingdom = "United Kingdom",
  UnitedStates = "United States",
  Canada = "Canada",
}

export enum SepaCountries {
  Andorra = "Andorra",
  Austria = "Austria",
  Belgium = "Belgium",
  Bulgaria = "Bulgaria",
  Croatia = "Croatia",
  Cyprus = "Cyprus",
  CzechRepublic = "Czech Republic",
  Denmark = "Denmark",
  Estonia = "Estonia",
  Finland = "Finland",
  France = "France",
  Germany = "Germany",
  Greece = "Greece",
  Hungary = "Hungary",
  Iceland = "Iceland",
  Ireland = "Ireland",
  Italy = "Italy",
  Latvia = "Latvia",
  Liechtenstein = "Liechtenstein",
  Lithuania = "Lithuania",
  Luxembourg = "Luxembourg",
  Malta = "Malta",
  Monaco = "Monaco",
  Netherlands = "Netherlands",
  Norway = "Norway",
  Poland = "Poland",
  Portugal = "Portugal",
  Romania = "Romania",
  SanMarino = "San Marino",
  Slovakia = "Slovakia",
  Slovenia = "Slovenia",
  Spain = "Spain",
  Sweden = "Sweden",
  Switzerland = "Switzerland",
  UnitedKingdom = "United Kingdom",
  VaticanCity = "Vatican City",
}

export function usesACH(location?: Location): boolean {
  return location?.country === Countries.UnitedStates;
}

export function usesPad(location?: Location): boolean {
  return location?.country === Countries.Canada;
}

export function usesBacs(location?: Location): boolean {
  return location?.country === Countries.UnitedKingdom;
}

export function usesSepa(location?: Location): boolean {
  return Object.values(SepaCountries).includes(
    location?.country as SepaCountries
  );
}
export function uses3dsCreditCard(location?: Location): boolean {
  return location?.currencyCode === "GBP" || location?.currencyCode === "EUR";
}

export function isUSDAccount(location?: Location): boolean {
  return location?.currencyCode === "USD";
}
